<template>
    <div class="flex mt-[42px] mb-[27px] justify-between h-[42px]">
        <h1
            class="text-[21px] font-medium leading-normal tracking-small text-gray-800"
        >
            {{ t("vue.dns_tools") }}
        </h1>
    </div>

    <div>
        <BasicTabs :tabs="tabs" :tab-key="activeTab" />
    </div>

    <div class="mt-[44px] mb-[120px] w-full">
        <div
            v-if="activeTab === 'dmarc-configurator'"
            class="flex justify-center"
        >
            <div
                class="w-full max-w-[1256px] rounded-[12.75px] border border-gray-200 bg-white px-[21px] py-[44px] flex flex-col items-center gap-[24px]"
            >
                <div class="flex flex-col items-center gap-[8px] text-center">
                    <h2
                        class="text-[21px] font-semibold leading-[1.42] text-black max-w-[539px]"
                    >
                        {{ t("vue.dmarc_record_configurator") }}
                    </h2>
                    <p
                        class="text-[12.25px] leading-[1.42] text-black max-w-[366px]"
                    >
                        {{ t("vue.dmarc_record_configurator_desc") }}
                    </p>
                </div>
                <div id="dns-widget-container" class="w-full"></div>
            </div>
        </div>

        <div v-if="activeTab === 'dns-scanner'" class="flex justify-center">
            <div
                class="w-full max-w-[1256px] rounded-[12.75px] border border-gray-200 bg-white px-[21px] py-[44px] flex flex-col items-center gap-[24px]"
            >
                <div class="flex flex-col items-center gap-[8px] text-center">
                    <h2
                        class="text-[21px] font-semibold leading-[1.42] text-black max-w-[539px]"
                    >
                        {{ t("vue.dns_record_configurator") }}
                    </h2>
                    <p
                        class="text-[12.25px] leading-[1.42] text-black max-w-[366px]"
                    >
                        {{ t("vue.dns_record_configurator_desc") }}
                    </p>
                </div>

                <div
                    id="dmarc-widget"
                    :data-lang="widgetLang"
                    data-btn-color="#161E2E"
                    data-btn-hover="#2d3748"
                    data-btn-radius="13"
                    data-btn-height="46"
                    data-btn-font-size="16"
                    data-btn-padding="28"
                    data-btn-border-color="#161E2E"
                    data-btn-border-width="0"
                    data-input-height="48"
                    data-input-border="#DADADA"
                    data-input-focus="#ff421e"
                    data-input-radius="8"
                    data-input-border-width="2"
                ></div>
            </div>
        </div>

        <div v-if="activeTab === 'spf-scanner'" class="flex justify-center">
            <div
                class="w-full max-w-[1256px] rounded-[12.75px] border border-gray-200 bg-white px-[21px] py-[44px] flex flex-col items-center gap-[24px]"
            >
                <div class="flex flex-col items-center gap-[8px] text-center">
                    <h2
                        class="text-[21px] font-semibold leading-[1.42] text-black max-w-[539px]"
                    >
                        {{ t("vue.spf_record_configurator") }}
                    </h2>
                    <p
                        class="text-[12.25px] leading-[1.42] text-black max-w-[366px]"
                    >
                        {{ t("vue.spf_record_configurator_desc") }}
                    </p>
                </div>

                <div
                    id="spf-widget"
                    :data-lang="widgetLang"
                    data-btn-color="#161E2E"
                    data-btn-hover="#2d3748"
                    data-btn-radius="13"
                    data-btn-height="46"
                    data-btn-font-size="16"
                    data-btn-padding="28"
                    data-btn-border-color="#161E2E"
                    data-btn-border-width="0"
                    data-input-height="48"
                    data-input-border="#DADADA"
                    data-input-focus="#ff421e"
                    data-input-radius="8"
                    data-input-border-width="2"
                ></div>
            </div>
        </div>

        <div v-if="activeTab === 'dkim-scanner'" class="flex justify-center">
            <div
                class="w-full max-w-[1256px] rounded-[12.75px] border border-gray-200 bg-white px-[21px] py-[44px] flex flex-col items-center gap-[24px]"
            >
                <div class="flex flex-col items-center gap-[8px] text-center">
                    <h2
                        class="text-[21px] font-semibold leading-[1.42] text-black max-w-[539px]"
                    >
                        {{ t("vue.dkim_record_configurator") }}
                    </h2>
                    <p
                        class="text-[12.25px] leading-[1.42] text-black max-w-[366px]"
                    >
                        {{ t("vue.dkim_record_configurator_desc") }}
                    </p>
                </div>

                <div
                    id="dkim-widget"
                    :data-lang="widgetLang"
                    data-btn-color="#161E2E"
                    data-btn-hover="#2d3748"
                    data-btn-radius="13"
                    data-btn-height="46"
                    data-btn-font-size="16"
                    data-btn-padding="28"
                    data-btn-border-color="#161E2E"
                    data-btn-border-width="0"
                    data-input-height="48"
                    data-input-border="#DADADA"
                    data-input-focus="#ff421e"
                    data-input-radius="8"
                    data-input-border-width="2"
                ></div>
            </div>
        </div>

        <div v-if="activeTab === 'bimi-scanner'" class="flex justify-center">
            <div
                class="w-full max-w-[1256px] rounded-[12.75px] border border-gray-200 bg-white px-[21px] py-[44px] flex flex-col items-center gap-[24px]"
            >
                <div class="flex flex-col items-center gap-[8px] text-center">
                    <h2
                        class="text-[21px] font-semibold leading-[1.42] text-black max-w-[539px]"
                    >
                        {{ t("vue.bimi_record_configurator") }}
                    </h2>
                    <p
                        class="text-[12.25px] leading-[1.42] text-black max-w-[366px]"
                    >
                        {{ t("vue.bimi_record_configurator_desc") }}
                    </p>
                </div>

                <div
                    id="bimi-widget"
                    :data-lang="widgetLang"
                    data-btn-color="#161E2E"
                    data-btn-hover="#2d3748"
                    data-btn-radius="13"
                    data-btn-height="46"
                    data-btn-font-size="16"
                    data-btn-padding="28"
                    data-btn-border-color="#161E2E"
                    data-btn-border-width="0"
                    data-input-height="48"
                    data-input-border="#DADADA"
                    data-input-focus="#ff421e"
                    data-input-radius="8"
                    data-input-border-width="2"
                ></div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import {
    computed,
    nextTick,
    onBeforeUnmount,
    onMounted,
    ref,
    watch,
} from "vue";
import { usePage } from "@inertiajs/vue3";
import route from "ziggy-js";
import BasicTabs from "@/components/Atomic/Tabs/BasicTabs.vue";
import type TabItem from "@/types/Settings/TabItem";
import { Code } from "lucide-vue-next";
import { useTranslations } from "@/composables/useTranslations.ts";

interface Props {
    lang?: string;
}

const { t } = useTranslations();

const props = defineProps<Props>();

const defaultTab = "dmarc-configurator" as const;
const allowedTabs = [
    "dmarc-configurator",
    "dns-scanner",
    "spf-scanner",
    "dkim-scanner",
    "bimi-scanner",
] as const;

type TabKey = (typeof allowedTabs)[number];

type WidgetConfig = {
    containerId: string;
    scriptSrc?: string;
    type?: "iframe";
};

const widgets = {
    "dmarc-configurator": {
        containerId: "dns-widget-container",
        type: "iframe",
    },
    "dns-scanner": {
        containerId: "dmarc-widget",
        scriptSrc: "https://dns-checker-widget.lovable.app/dmarc-widget.js",
    },
    "spf-scanner": {
        containerId: "spf-widget",
        scriptSrc: "https://dns-checker-widget.lovable.app/spf-widget.js",
    },
    "dkim-scanner": {
        containerId: "dkim-widget",
        scriptSrc: "https://dns-checker-widget.lovable.app/dkim-widget.js",
    },
    "bimi-scanner": {
        containerId: "bimi-widget",
        scriptSrc: "https://dns-checker-widget.lovable.app/bimi-widget.js",
    },
} satisfies Record<TabKey, WidgetConfig>;

const tabs: TabItem[] = [
    {
        title: t("vue.dmarc_configurator"),
        key: "dmarc-configurator",
        icon: Code,
        url: route("dns-tools.index", { tab: "dmarc-configurator" }),
    },
    {
        title: t("vue.dns_scanner"),
        key: "dns-scanner",
        icon: Code,
        url: route("dns-tools.index", { tab: "dns-scanner" }),
    },
    {
        title: t("vue.spf_scanner"),
        key: "spf-scanner",
        icon: Code,
        url: route("dns-tools.index", { tab: "spf-scanner" }),
    },
    {
        title: t("vue.dkim_scanner"),
        key: "dkim-scanner",
        icon: Code,
        url: route("dns-tools.index", { tab: "dkim-scanner" }),
    },
    {
        title: t("vue.bimi_scanner"),
        key: "bimi-scanner",
        icon: Code,
        url: route("dns-tools.index", { tab: "bimi-scanner" }),
    },
];

const page = usePage();

const widgetLang = computed(() => (props.lang === "cs" ? "cs" : "en"));
const configuratorIframe = ref<HTMLIFrameElement | null>(null);
const configuratorBaseUrl = "https://dns-configurator.lovable.app";

const getTabFromUrl = (url: string): TabKey => {
    const queryIndex = url.indexOf("?");

    if (queryIndex === -1) {
        return defaultTab;
    }

    const params = new URLSearchParams(url.slice(queryIndex + 1));
    const tab = params.get("tab");

    if (tab && allowedTabs.includes(tab as TabKey)) {
        return tab as TabKey;
    }

    return defaultTab;
};

const activeTab = computed<TabKey>(() => getTabFromUrl(page.url));

const handleWidgetResize = (event: MessageEvent) => {
    if (event.data && event.data.type === "dns-widget-resize") {
        if (configuratorIframe.value) {
            configuratorIframe.value.style.height = `${event.data.height}px`;
        }
    }
};

const loadWidget = async (key: TabKey) => {
    await nextTick();

    const widget = widgets[key];
    const container = document.getElementById(widget.containerId);

    if (!container) return;

    if (widget.type === "iframe") {
        if (container.querySelector(`iframe[data-widget="${key}"]`)) return;

        const params = new URLSearchParams();
        params.set("embed", "true");
        params.set("lang", widgetLang.value);
        params.set("step1ButtonColor", "#161E2E");
        params.set("step1ButtonRadius", "12");
        params.set("ctaColor", "#161E2E");
        params.set("darkMode", "light");

        const iframe = document.createElement("iframe");
        iframe.src = `${configuratorBaseUrl}/?${params.toString()}`;
        iframe.style.width = "100%";
        iframe.style.minHeight = "200px";
        iframe.style.border = "none";
        iframe.style.overflow = "hidden";
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("scrolling", "no");
        iframe.setAttribute("allowtransparency", "true");
        iframe.setAttribute("data-widget", key);

        container.appendChild(iframe);
        configuratorIframe.value = iframe;
        return;
    }

    if (container.querySelector(`script[data-widget="${key}"]`)) return;

    container.setAttribute("data-lang", widgetLang.value);

    const script = document.createElement("script");
    if (!widget.scriptSrc) return;
    script.src = widget.scriptSrc;
    script.async = true;
    script.setAttribute("data-widget", key);

    container.appendChild(script);
};

watch(
    activeTab,
    (value) => {
        void loadWidget(value);
    },
    { immediate: true },
);

onMounted(() => {
    window.addEventListener("message", handleWidgetResize);
});

onBeforeUnmount(() => {
    window.removeEventListener("message", handleWidgetResize);
});
</script>
